import AudioRecorder from 'audio-recorder-polyfill';
// @ts-ignore
window.MediaRecorder = AudioRecorder;
